import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLogoutQueueStore = defineStore('logout-queue', () => {
  const queue = ref(Promise.resolve())
  const status = ref<'off' | 'pending' | 'done'>('off')

  function enqueue(fn: () => Promise<void>) {
    return new Promise<void>((resolve, reject) => {
      queue.value = queue.value
        .then(async () => {
          if (status.value !== 'off') {
            return
          }
          status.value = 'pending'
          await fn()
          status.value = 'done'
        })
        .then(resolve)
        .catch(reject)
    })
  }

  function reset() {
    queue.value = Promise.resolve()
    status.value = 'off'
  }

  return {
    enqueue,
    reset,
  }
})
